import React from 'react';
import { useParams } from 'react-router-dom';
import ViewRiskProfile from './ViewRiskProfile';
import ViewOnboarding from './ViewOnboarding';

const PublicViewPage = () => {
  const { kind, token } = useParams();
  if (kind === 'onboarding') return <ViewOnboarding publicToken={token} />;
  if (kind === 'risk-profile') return <ViewRiskProfile publicToken={token} />;
  return <div className="min-h-screen flex items-center justify-center bg-slate-50">This link is not valid.</div>;
};

export default PublicViewPage;
